import { ptBrCommonFieldsTranslations } from "../common";

export const user = {
  name: "Usuário |||| Usuários",
  tabs: {
    general: "Geral",
    emailSignature: "Assinatura de E-mail",
  },
  fields: {
    id: "ID do Usuário",
    email: "Email",
    password: "Senha",
    name: "Nome",
    userGroupsIds: "Grupos",
    groupIds: "Grupos",
    roleIds: "Perfis",
    createdAt: ptBrCommonFieldsTranslations.createdAt,
    updatedAt: ptBrCommonFieldsTranslations.updatedAt,
    // Email signature fields
    title: "Cargo",
    phone: "Telefone",
    emailSignature: "Assinatura de E-mail",
    isAway: "Estou ausente",
    awayMessage: "Mensagem de ausência",
  },
  emailSignature: {
    description: "Configure sua assinatura de e-mail. Essas configurações serão usadas ao enviar e-mails pelo sistema.",
    titleHelper: "Seu cargo (ex: Engenheiro de Suporte, Gerente de Vendas)",
    phoneHelper: "Número de telefone para sua assinatura de e-mail",
    signatureHelper: "Assinatura HTML do e-mail. Suporta variáveis: {{name}}, {{title}}, {{email}}, {{phone}}",
    awayStatus: "Status de Ausência",
    awayMessageHelper: "Mensagem de resposta automática quando você estiver ausente",
  },
};
